import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-return-invoice-list',
  templateUrl: './return-invoice-list.component.html',
  styleUrls: ['./return-invoice-list.component.css']
})
export class ReturnInvoiceListComponent implements OnInit {

  public menu_item_id = '22';
  public add_auth;
  public del_auth;
  public edit_auth;
  model = {
    'table_name': 'return_invoice', 'fromDate': new Date(), 'toDate': new Date(),
    'return_invoice_no': '', 'branch_id': '0', 'store_id': '0', 'customer_name': '',
    'mobile': '', 'title': 'قائمة المرتجعات'
  };

  private dp = [];
  displayedColumns = ['return_invoice_no', 'return_date', 'customer_name', 'mobile', 'final_total', 
    'payment_method', 'created_by', 'branch_name', 'detail', 'print', 'edit']; // , 'del'
  displayedColumns2 = ['return_invoice_no', 'return_date', 'customer_name', 'mobile', 'final_total', 
    'payment_method', 'created_by', 'branch_name'];
    
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  private inv_list = [];
  from_date;
  to_date;

  branchList = [];
  allStoreList = [];
  storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];

  Return_Inv_List; Success_Msg; Error_Msg; Del_Msg; From_Date; To_Date;
  Search_Msg; 

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService, private router: Router) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Return_Inv_List').subscribe((res: string) => {
      this.Return_Inv_List = res;
    });
    this.model['title'] = this.Return_Inv_List;


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);

    // this.model['fromDate'] = undefined;
    // this.model['toDate'] = undefined;
    // this.from_date = (this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
    //   this.model['fromDate'].getDate());
    // this.to_date = (this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
    //   this.model['toDate'].getDate());

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  search() {
    this.inv_list = [];
    this.dp = [];

    if ((this.model['fromDate'] == undefined || this.model['toDate'] == undefined) &&
      this.model['invoice_no'] == '') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getRetInvoiceList' };  

    if (this.model['return_invoice_no'] != '') {
      obj['return_invoice_no'] = this.model['return_invoice_no'];
      obj['store_list'] = this.allStoreList;
    }
    else {
      if (this.model['fromDate'] != undefined) {
        this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) +
          "-" + this.model['fromDate'].getDate() + ' 00:00:00';
        obj['from_date'] = this.from_date;
      }

      if (this.model['toDate'] != undefined) {
        this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) +
          "-" + this.model['toDate'].getDate() + ' 23:59:59';
        obj['to_date'] = this.to_date;
      }

      // if (this.model['inv_status'] != '0')
      //   obj['inv_status'] = this.model['inv_status'];

      if (this.model['customer_name'] != '')
        obj['customer_name'] = this.model['customer_name'];

      if (this.model['mobile'] != '')
        obj['mobile'] = this.model['mobile'];

      if (this.model['branch_id'] == '0')
        obj['store_list'] = this.allStoreList;
      else {
        if (this.model['store_id'] != '0')
          obj['store_id'] = this.model['store_id'];
        else {
          let allStoreList = [];
          this.storeList.forEach(element => {
            if (element.store_id != '0')
              allStoreList.push({ 'store_id': element.store_id });
          });
          obj['store_list'] = allStoreList;
        }
      }
    }

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

    // let condition = "";
    // "`return_invoice`.`return_date` BETWEEN '" + this.from_date + "' AND '" + this.to_date +
    //   "' AND `return_invoice`.`status` = '1' "; // AND `invoice`.`created_by` = `user`.`user_name` AND `user`.`employee_id` = `employee`.`employee_id` AND " + 
    //  "`employee`.`branch_id` = `branch`.`branch_id` ";

    // if (this.model['fromDate'] != undefined) {
    //   this.from_date = (this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
    //     this.model['fromDate'].getDate() + " 00:00:00");
    //   condition += " AND `return_invoice`.`return_date` >= '" + this.from_date + "'";
    // }

    // if (this.model['toDate'] != undefined) {
    //   this.to_date = (this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
    //     this.model['toDate'].getDate() + " 23:59:59");
    //   condition += " AND `return_invoice`.`return_date` <= '" + this.to_date + "'";
    // }

    // if (this.model['ret_invoice_no'] != '')
    //   condition = " AND `return_invoice`.`return_invoice_no` LIKE '%" + this.model['ret_invoice_no'] + "%' ";

    // let index = 1;
    // if (this.model['branch_id'] == '0') {
    //   if (this.allStoreList.length == 1)
    //     condition += " AND `return_invoice`.`store_id` = '" + this.allStoreList[0]['store_id'] + "'";
    //   else {
    //     condition += " AND `return_invoice`.`store_id` IN (";
    //     index = 1;
    //     this.allStoreList.forEach(element => {
    //       if (index < this.allStoreList.length)
    //         condition += " '" + element.store_id + "',";
    //       else if (index == this.allStoreList.length)
    //         condition += " '" + element.store_id + "'";

    //       index++;
    //     });
    //     condition += ")";
    //   }
    // }
    // else {
    //   if (this.model['store_id'] != '0')
    //     condition += " AND `return_invoice`.`store_id` = '" + this.allStoreList[0]['store_id'] + "'";
    //   else {
    //     if (this.storeList.length == 2)
    //       condition += " AND `return_invoice`.`store_id` = '" + this.storeList[1]['store_id'] + "'";
    //     else {
    //       condition += " AND `return_invoice`.`store_id` IN (";
    //       index = 1;
    //       this.storeList.forEach(element => {
    //         if (element.store_id != '0') {
    //           if (index < this.storeList.length)
    //             condition += " '" + element.store_id + "',";
    //           else if (index == this.storeList.length)
    //             condition += " '" + element.store_id + "'";
    //         }
    //         index++;
    //       });
    //       condition += ")";
    //     }
    //   }
    // }

    // let query = "SELECT `return_invoice`.* FROM `return_invoice` WHERE `return_invoice`.`status` != '0'" + condition;
    // let obj = { cmd: 'getList', query: query };
    // //console.log(query);

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     let result = data.data['list'];
    //     let counter = 0;
    //     let result3;

    //     result.forEach(element => {
    //       element.return_date = (element.return_date).substring(0, 10);
    //       element.payment_method = '';

    //       query = "SELECT `payment_type`.`payment_type_name` FROM `ret_inv_payment_method`, `payment_type` WHERE `ret_inv_payment_method`.`return_invoice_no` = '" +
    //         element.return_invoice_no + "' AND `ret_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id`";
    //       obj = { cmd: 'getList', query: query };
    //       this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //         .subscribe(data => {
    //           this.applicationConstants.appComp.hideBusyCursor();
    //           result3 = data.data['list'];
    //           result3.forEach(element2 => {
    //             if (element.payment_method != '')
    //               element.payment_method += ' - ';
    //             element.payment_method += element2.payment_type_name
    //           });
    //         });


    //       //element.inv_type = "فاتورة";
    //       element.final_total = ((Number(element.total) - Number(element.discount)) + Number(element.tax)).toFixed(2);


          //   if (element.customer_no != '') {
          //     query = "SELECT `customer_name`, `mobile` FROM `customer` WHERE `customer_no` = '" + element.customer_no + "'";
          //     obj = { cmd: 'getList', query: query };
          //     let result2;

          //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          //       .subscribe(data => {
          //         this.applicationConstants.appComp.hideBusyCursor();
          //         result2 = data.data['list'];
          //         element.customer_name = result2[0].customer_name;
          //         element.mobile = result2[0].mobile;

          //         query = "SELECT `payment_type`.`payment_type_name` FROM `ret_inv_payment_method`, `payment_type` WHERE `ret_inv_payment_method`.`return_invoice_no` = '" +
          //           element.return_invoice_no + "' AND `ret_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id`";
          //         obj = { cmd: 'getList', query: query };

          //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          //           .subscribe(data => {
          //             this.applicationConstants.appComp.hideBusyCursor();
          //             result3 = data.data['list'];
          //             result3.forEach(element2 => {
          //               if (element.payment_method != '')
          //                 element.payment_method += ' - ';
          //               element.payment_method += element2.payment_type_name
          //             });

          //             counter++;
          //             if (counter == result.length) {
          //               this.inv_list = result;
          //               this.filterByCust();
          //             }
          //           });
          //       });
          //   }
          //   else {
          //     element.mobile = '';
          //     query = "SELECT `payment_type`.`payment_type_name` FROM `ret_inv_payment_method`, `payment_type` WHERE `ret_inv_payment_method`.`return_invoice_no` = '" +
          //       element.return_invoice_no + "' AND `ret_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id`";
          //     obj = { cmd: 'getList', query: query };

          //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          //       .subscribe(data => {
          //         this.applicationConstants.appComp.hideBusyCursor();
          //         result3 = data.data['list'];
          //         result3.forEach(element2 => {
          //           if (element.payment_method != '')
          //             element.payment_method += ' - ';
          //           element.payment_method += element2.payment_type_name
          //         });

          //         counter++;
          //         if (counter == result.length) {
          //           this.inv_list = result;
          //           this.filterByCust();
          //         }
          //       });
          //   }
      //   });
      //   this.dp = data.data['list'];
      //   this.dataSource = new MatTableDataSource(this.dp);
      //   this.dataSource.sort = this.sort;
      // });

  }

  print(return_invoice_no = null) {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    if (return_invoice_no == null) {
      html_data = '<table cellpadding="8" cellspacing="0"><tr>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + this.from_date + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td>';
      html_data += '<td width="33%"> </td></tr>';
      html_data += '</table>';
      //html_data += '<tr><td width="33%"> رقم الفاتورة: ' + this.model['ret_invoice_no'] + ' </td>';
      // html_data += '<tr><td width="33%"> النوع: ';
      // this.typeList.forEach(element => {
      //   if (element.type_id == this.model['inv_type'])
      //     html_data += element.type_name;
      // });

      // html_data += '</td><td width="33%"> الحالة: ';
      // this.statusList.forEach(element => {
      //   if (element.status_id == this.model['inv_status'])
      //     html_data += element.status_name;
      // });

      let table = (document.getElementById('ret_inv_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.generatePDF + "?type=return_invoice&no=" + return_invoice_no, "_blank");
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  editRetInv(row) {
    if (row.invoice_no != '')
      this.router.navigate(['sub_menu/1/return_invoice/' + row.return_invoice_no]);
    else
      this.router.navigate(['sub_menu/1/invoice/return_invoice/edit/' + row.return_invoice_no]);
  }

  delRetInv(row) {
    if (confirm(this.Del_Msg)) {
      let values = [];
      values.push({ 'table_name': this.model['table_name'], 'return_invoice_no': row.return_invoice_no });
      values.push({ 'table_name': 'return_invoice_item', 'return_invoice_no': row.return_invoice_no });
      values.push({ 'table_name': 'ret_inv_payment_method', 'return_invoice_no': row.return_invoice_no });
      values.push({ 'table_name': 'stock_damage', 'return_invoice_no': row.return_invoice_no });

      let obj = { cmd: 'deleteRec', values: values };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          //console.log(data);
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }



}
